export const about = {
  // Hero Section
  heroTitle: 'ICAN',
  heroSubtitle: 'Learn Space, Build the Future',
  heroDescription: 'ICAN is an innovative educational institution that develops future core competencies through cosmic thinking',

  // Stats
  stat1Value: '8 Weeks',
  stat1Label: 'EDUSPACE Program',
  stat2Value: 'Grades 4-5',
  stat2Label: 'Customized Education',
  stat3Value: '7 Topics',
  stat3Label: 'Space Exploration',
  stat4Value: '100%',
  stat4Label: 'Hands-On Learning',

  // Mission Section
  missionTitle: 'Our',
  missionTitleHighlight: 'Mission',
  missionParagraph1: 'So that exploratory learning leads to data, problem-solving, and design competencies, ICAN designs curriculum with cosmic thinking.',
  missionParagraph2: 'We do not simply transfer knowledge, but help students experience true learning through the process of exploring, discovering, and creating on their own. Through the grand theme of space, students simultaneously develop both macro thinking and micro analytical skills.',

  // Core Values Section
  valuesTitle: 'Core',
  valuesTitleHighlight: 'Values',
  valuesSubtitle: 'Four core values that form the foundation of ICAN educational philosophy',

  value1Title: 'Problem-Solving First',
  value1Description: 'EDUSPACE develops critical thinking and creativity by solving real space problems every day.',

  value2Title: 'Hands-On Learning',
  value2Description: 'Real learning happens through experiential projects where students create, experiment, and present.',

  value3Title: 'Structured Curriculum',
  value3Description: 'Daily activities from Monday to Friday develop learning skills, research, production, and presentation abilities in a balanced way.',

  value4Title: 'Elementary-Focused',
  value4Description: 'We provide educational methods and difficulty levels optimized for the developmental stage of elementary grades 4-5.',

  // Team Section
  teamTitle: 'Expert',
  teamTitleHighlight: 'Team',
  teamSubtitle: 'Top experts in space and education',

  team1Name: 'Dr. Wooju Kim',
  team1Role: 'CEO / Education Director',
  team1Description: 'Ph.D. in Astronomy from Seoul National University, Former NASA Researcher',
  team1Skill1: 'Astronomy',
  team1Skill2: 'Space Science',
  team1Skill3: 'Curriculum Design',

  team2Name: 'Jihye Lee',
  team2Role: 'Curriculum Director',
  team2Description: 'Ph.D. in Aerospace Engineering from KAIST, Former NASA STEM Education Program Leader',
  team2Skill1: 'Aerospace Engineering',
  team2Skill2: 'Project-Based Learning',
  team2Skill3: 'STEAM Education',

  team3Name: 'Data Park',
  team3Role: 'Chief Technology Officer',
  team3Description: 'M.S. in Data Science from MIT, Former Google AI Researcher',
  team3Skill1: 'Data Science',
  team3Skill2: 'AI/ML',
  team3Skill3: 'Satellite Data Analysis',

  team4Name: 'Hyukshin Choi',
  team4Role: 'Education Innovation Team Lead',
  team4Description: 'Ed.D. from Harvard, Former Professor at International Space University',
  team4Skill1: 'Educational Psychology',
  team4Skill2: 'Learning Science',
  team4Skill3: 'Educational Technology',

  // Timeline Section
  timelineTitle: 'Growth',
  timelineTitleHighlight: 'Story',
  timelineSubtitle: 'ICAN\'s journey over the past 5 years',

  timeline1Year: '2020',
  timeline1Title: 'ICAN Founded',
  timeline1Description: 'Beginning of a new paradigm in space education',

  timeline2Year: '2021',
  timeline2Title: 'First Pilot Program',
  timeline2Description: 'Started space science education for elementary students',

  timeline3Year: '2022',
  timeline3Title: 'EDUSPACE Development',
  timeline3Description: 'Designed problem-solving centered 8-week curriculum',

  timeline4Year: '2023',
  timeline4Title: 'EDUSPACE Official Launch',
  timeline4Description: 'Launched customized program for elementary grades 4-5',

  timeline5Year: '2024',
  timeline5Title: 'Program Expansion',
  timeline5Description: 'Completed 7 topics, established systematic Monday-Friday learning structure',

  // Partners Section
  partnersTitle: 'Partners &',
  partnersTitleHighlight: 'Collaboration',
  partnersSubtitle: 'World-class education through collaboration with global institutions',

  partner1Name: 'NASA',
  partner1Description: 'STEM Education Partnership',

  partner2Name: 'KAIST',
  partner2Description: 'Joint research and educational programs',

  partner3Name: 'KARI',
  partner3Description: 'Korea Aerospace Research Institute collaboration',

  partner4Name: 'Seoul Nat\'l Univ',
  partner4Description: 'Astronomy department industry-academia cooperation',

  partner5Name: 'Google',
  partner5Description: 'Data science education support',

  partner6Name: 'SpaceX',
  partner6Description: 'Space industry insights sharing',

  // CTA Section
  ctaTitle: 'Let\'s Build the',
  ctaTitleHighlight: 'Future',
  ctaSubtitle: 'Start your journey of cosmic thinking with ICAN',
  ctaButton1: 'Request Consultation',
  ctaButton2: 'View Curriculum'
};
